import { match } from 'ts-pattern'
import { type ExtraPackageBoost, ExtraPackageBoostType } from '../api/types'

export const sortBoostsPriority = (boosts?: ExtraPackageBoost[]) => {
  return boosts
    ?.map(boost =>
      match(boost.type)
        .with(ExtraPackageBoostType.Coupon, () => ({
          ...boost,
          priority: -1,
        }))
        .with(ExtraPackageBoostType.Campaign, () => ({
          ...boost,
          priority: 0,
        }))
        .with(ExtraPackageBoostType.Tier, () => ({
          ...boost,
          priority: 2,
        }))
        .with(ExtraPackageBoostType.Membership, () => ({
          ...boost,
          priority: 3,
        }))

        .exhaustive(),
    )
    .sort((a, b) => a.priority - b.priority)
}
